// 以下均为处理路由树
import routerInit from "@/CommonDP/router";
import { isArray } from "lodash";
// import { v4 as uuidv4 } from 'uuid';
export function getTreeData(data) {
  for (var i = 0; i < data.length; i++) {
    if (data[i].isLeaf === 1) {
      // children若为空数组，则将children设为undefined
      data[i].childList = [];
    } else {
      // children若不为空数组，则继续 递归调用 本方法
      getTreeData(data[i].childList);
    }
  }

  return data;
}
// 递归tree，修改所有树结构，并赋值
export function getMenuList(data) {
  const item = [];
  const router = routerInit();

  data.map((list) => {
    const newData = {};
    newData.name = list.permissionName;
    newData.permissionKey = list.permissionKey;
    newData.path = list.location;
    newData.id = list.permissionId;
    newData.resourceType = list.resourceType;
    newData.icon1 = router.resolve({
      name: newData.permissionKey
    })?.route?.meta?.icon1;
    newData.icon2 = router.resolve({
      name: newData.permissionKey
    })?.route?.meta?.icon2;
    newData.unReadNum = list.unReadNum ? list.unReadNum : 0;
    newData.sub = list.childList && !list.useTemplate ? getMenuList(list.childList) : []; // 如果还有子集，就再次调用自己
    item.push(newData);
  });
  return item;
}

// 获取应用中的数据
// 递归tree，修改所有树结构，并赋值
export function getMenuListApplication(data) {
  const item = [];
  const router = routerInit();

  data.map((list) => {
    const newData = {};
    newData.name = list.permissionName;
    newData.permissionKey = list.permissionKey;
    newData.path = list.location;
    newData.id = list.permissionId;
    newData.resourceType = list.resourceType;
    newData.icon = router.resolve({
      name: newData.permissionKey
    })?.route?.meta?.icon;
    newData.sub = list.childList ? getMenuListApplication(list.childList) : []; // 如果还有子集，就再次调用自己
    item.push(newData);
  });
  return item;
}

export class TreeUtils {
  constructor(model) {
    if (!model.idFieldName) {
      throw new Error("参数错误：idFieldName 不能为空");
    }
    if (!model.childrenFieldName) {
      throw new Error("参数错误：childrenFieldName 不能为空");
    }
    this.model = model;
    this.idFieldName = model.idFieldName;
    this.childrenFieldName = model.childrenFieldName;
    this.nameFieldName = model.nameFieldName;
    this.parentIdFieldName = model.parentIdFieldName;
  }

  /**
   * 修剪树，只保留至某一层级。并移除不需要的节点（如果有不必要的节点）
   * @param {必填} reservedLevel 要保留的 level, 从 0 开始
   * @param {*} excludedNodeIds 要移除的节点，数组，可选
   * @param {*} idFieldName 节点 id 的字段名称
   * @param {*} childrenFieldName 子节点的字段名称
   */
  cutTree(treeNodes, reservedLevel, excludedNodeIds) {
    if (reservedLevel < 0) {
      return null;
    }
    if (!treeNodes || !treeNodes.length) {
      return [];
    }
    let excludedIds = [];
    if (isArray(excludedNodeIds)) {
      excludedIds = excludedNodeIds;
    }
    const resultNodes = treeNodes.filter((item) => !excludedIds.includes(item[this.idFieldName]));
    if (!resultNodes.length) {
      return [];
    }
    for (const node of resultNodes) {
      const childNodes = this.cutTree(node[this.childrenFieldName], reservedLevel - 1, excludedIds);
      node[this.childrenFieldName] = childNodes;
    }
    return resultNodes;
  }

  // 广度优先遍历
  // 注意：callback(node) 如果返回 true, 则会停止遍历
  wtravelAll(nodes, childrenFieldName, childrenOnly, callback) {
    const queue = [...nodes];
    this._doWTravel(queue, childrenFieldName, childrenOnly, callback);
  }

  // 广度优先遍历
  wtravel(rootNode, childrenFieldName, childrenOnly, callback) {
    if (!rootNode) {
      return;
    }
    if (!childrenFieldName) {
      childrenFieldName = this.childrenFieldName;
    }
    if (this.emptyArray(rootNode[childrenFieldName])) {
      callback(rootNode);
      return;
    }
    const queue = [rootNode];
    this._doWTravel(queue, childrenFieldName, childrenOnly, callback);
  }

  _doWTravel(queue, childrenFieldName, childrenOnly, callback) {
    if (!childrenFieldName) {
      childrenFieldName = this.childrenFieldName;
    }
    while (queue.length > 0) {
      const node = queue.shift();
      if (this.emptyArray(node[childrenFieldName])) {
        const needStop = callback(node);
        if (needStop) {
          return;
        }
      } else {
        if (!childrenOnly) {
          const needStop = callback(node);
          if (needStop) {
            return;
          }
        }
        queue.push(...node[childrenFieldName]);
      }
    }
  }

  findTreeNodes(treeNodes, nodeIds) {
    if (!treeNodes || !treeNodes.length) {
      return [];
    }
    if (!nodeIds || !nodeIds.length) {
      return [];
    }
    const idFieldName = this.idFieldName;
    const childrenFieldName = this.childrenFieldName;
    if (!idFieldName) {
      throw new Error("参数错误：idFieldName 不能为空");
    }
    if (!childrenFieldName) {
      throw new Error("参数错误：childrenFieldName 不能为空");
    }
    const nodes = [];
    this.wtravelAll(treeNodes, childrenFieldName, false, (node) => {
      if (nodeIds.includes(node[idFieldName])) {
        nodes.push(node);
        if (nodes.length === nodeIds.length) {
          return true;
        }
      }
    });
    return nodes;
  }

  addNodeTo(parentNode, childNodeToAdd, beforeAddToParentCallback = () => {}) {
    if (!parentNode) {
      throw new Error("参数错误：parentNode 不能为空");
    }
    if (!childNodeToAdd) {
      throw new Error("参数错误：childNode 不能为空");
    }
    if (!this.idFieldName) {
      throw new Error("参数错误：idFieldName 不能为空");
    }
    if (!this.childrenFieldName) {
      throw new Error("参数错误：childrenFieldName 不能为空");
    }
    if (!this.nameFieldName) {
      throw new Error("参数错误：nameFieldName 不能为空");
    }
    const children = parentNode[this.childrenFieldName];
    if (!children) {
      const newChildNode = JSON.parse(JSON.stringify(childNodeToAdd));
      newChildNode[this.parentIdFieldName] = parentNode[this.idFieldName];
      beforeAddToParentCallback(newChildNode, parentNode);
      parentNode[this.childrenFieldName] = [newChildNode];
      return;
    }
    // 找到同名的节点，如果找到了，则要合并，没找到就添加
    let found = false;
    for (const node of children) {
      if (node[this.nameFieldName] === childNodeToAdd[this.nameFieldName]) {
        // 需要合并
        found = true;
        this.mergeTree(node, childNodeToAdd);
      }
    }
    if (!found) {
      // 不需要合并，直接添加
      const newChildNode = JSON.parse(JSON.stringify(childNodeToAdd));
      newChildNode[this.parentIdFieldName] = parentNode[this.idFieldName];
      beforeAddToParentCallback(newChildNode, parentNode);
      children.push(newChildNode);
    }
  }

  mergeTree(targetNode, nodeToMerge) {
    const childrenToMerge = nodeToMerge[this.childrenFieldName];
    if (!childrenToMerge || !childrenToMerge.length) {
      return;
    }
    childrenToMerge.forEach((nodeToMerge) => {
      this.addNodeTo(targetNode, nodeToMerge);
    });
  }

  emptyArray(array) {
    return !array || array.length === 0;
  }
}
